import { DataProvider } from 'react-admin';

export const createCustomDataProvider = (baseDataProvider: DataProvider): DataProvider => {
  return {
    ...baseDataProvider,
    getList: (resource, params) => {
      // If resource is "results", map it to form_submission
      if (resource === 'results') {
        return baseDataProvider.getList('form_submission', params);
      }
      return baseDataProvider.getList(resource, params);
    },
    getOne: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.getOne('form_submission', params);
      }
      return baseDataProvider.getOne(resource, params);
    },
    getMany: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.getMany('form_submission', params);
      }
      return baseDataProvider.getMany(resource, params);
    },
    getManyReference: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.getManyReference('form_submission', params);
      }
      return baseDataProvider.getManyReference(resource, params);
    },
    create: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.create('form_submission', params);
      }
      return baseDataProvider.create(resource, params);
    },
    update: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.update('form_submission', params);
      }
      return baseDataProvider.update(resource, params);
    },
    updateMany: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.updateMany('form_submission', params);
      }
      return baseDataProvider.updateMany(resource, params);
    },
    delete: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.delete('form_submission', params);
      }
      return baseDataProvider.delete(resource, params);
    },
    deleteMany: (resource, params) => {
      if (resource === 'results') {
        return baseDataProvider.deleteMany('form_submission', params);
      }
      return baseDataProvider.deleteMany(resource, params);
    },
  };
};
